import script from "./QihouYj.vue?vue&type=script&setup=true&lang=js"
export * from "./QihouYj.vue?vue&type=script&setup=true&lang=js"

import "./QihouYj.vue?vue&type=style&index=0&id=fe316fec&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe316fec"]])

export default __exports__